import { createSelector } from '@ngrx/store';
import { selectCoreState } from '../core-feature-selector';
import { isMainComplianceFormComplete } from 'src/app/shared/utilities/compliance-form-utilities';
import { enrollmentSubdomainCollection } from 'src/app/features/welcome/welcome.model';

const selectComplianceFormState = createSelector(
  selectCoreState,
  (state) => state.complianceForm,
);

export const selectComplianceForm = createSelector(
  selectComplianceFormState,
  (state) => state.complianceForm,
);

export const selectIsMainComplianceFormComplete = createSelector(
  selectComplianceFormState,
  (state) =>
    isMainComplianceFormComplete(
      state.complianceForm?.completed_question_groups ?? [],
    ),
);

export const selectIsEditingComplianceForm = createSelector(
  selectComplianceFormState,
  (enrollmentsState) => enrollmentsState.isEditing,
);

export const selectComplianceFormHasBeenChecked = createSelector(
  selectComplianceFormState,
  (state) => state.isChecked,
);

export const selectComplianceFormHasBeenLoaded = createSelector(
  selectComplianceFormState,
  (state) => state.isLoaded,
);

export const selectNavigationRouteFromCompliance = createSelector(
  selectComplianceFormState,
  (state) => state.returnToUrl,
);

export const selectCompletedComplianceQuestionSets = createSelector(
  selectComplianceFormState,
  (state) => state.complianceForm?.completed_question_groups ?? [],
);

export const selectIncompleteCarrierQuestionGroups = createSelector(
  selectCompletedComplianceQuestionSets,
  (completedQuestionGroups) =>
    enrollmentSubdomainCollection.filter(
      (enrollmentSubdomainQuestionGroup) =>
        !completedQuestionGroups.includes(enrollmentSubdomainQuestionGroup),
    ),
);
